import React, { Component } from 'react';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import { withApollo } from 'react-apollo';
import _isNumber from 'lodash/isNumber';
import _filter from 'lodash/filter';
import { Table as DvExTable } from '@devexpress/dx-react-grid-material-ui';
import Table from '../../components/Global/Table/Table';
import ErrorNotification from '../common/ErrorNotification';

import ShipmentReferencesTableMetadata from './ShipmentReferencesTable.metadata';
import * as Queries from '../../graphQL/queries/customFields';
import * as Mutations from '../../graphQL/mutations/customFields';
import { DEFAULT_ROWS_PER_PAGE } from '../../constants/constants';
import { AppContext } from '../../AppProvider';

const styles = () => ({
  tableRow: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(12,31,44, 0.04)'
    }
  }
});

export class ShipmentReferencesTable extends Component {
  state = {
    rowsSelected: [],
    items: [],
    loading: true,
    error: null,
    errorsOnSave: null,
    contact: null,
    isSubmitting: false,
    page: 0,
    rowsPerPage: localStorage.getItem('PropelRowsPerPage')
      ? parseInt(localStorage.getItem('PropelRowsPerPage'), 10)
      : DEFAULT_ROWS_PER_PAGE,
    totalCount: 0,
    deleting: false,
    isOpenFileUploader: false
  };

  async componentDidMount() {
    await this._getList();
  }

  async componentDidUpdate(prevProps) {
    if (prevProps.changedUtc !== this.props.changedUtc) {
      await this._getList();
    }
  }

  _getList = async () => {
    this.setState({ loading: true });
    const { client: ApolloClient } = this.props;

    const {
      orgInfo: { orgId }
    } = this.context.globalProps;

    const { page, rowsPerPage } = this.state;
    const offset = page * rowsPerPage;
    try {
      const {
        data: {
          customField: {
            paged: { results: items, totalCount }
          }
        }
      } = await ApolloClient.query({
        query: Queries.paged,
        variables: {
          orgId,
          limit: rowsPerPage,
          offset
        },
        fetchPolicy: 'network-only'
      });

      this.setState({
        items: ShipmentReferencesTableMetadata.formatData(items),
        totalCount: _isNumber(totalCount) ? totalCount : this.state.totalCount
      });
    } catch (error) {
      this.setState({
        error
      });
    } finally {
      this.setState({
        loading: false
      });
    }
  };

  _changePage = page => {
    this.setState({ page, loading: true }, this._getList);
  };

  _changeRowsPerPage = rowsPerPage => {
    localStorage.setItem('PropelRowsPerPage', rowsPerPage);
    this.setState({ rowsPerPage: rowsPerPage, page: 0 });
    const rows = rowsPerPage === 0 ? 100 : rowsPerPage;
    this.setState({ rowsPerPage: rows, page: 0, loading: true }, this._getList);
  };

  _handleSelectRow = rowsSelected => this.setState({ rowsSelected });

  _handleRowClick = row => this.props.onRowClick(row);

  _handleDelete = async () => {
    this.setState({ deleting: true });
    const { client: ApolloClient } = this.props;

    const { items, rowsSelected } = this.state;
    const itemsSelected = _filter(items, (item, index) =>
      rowsSelected.includes(index)
    );
    const itemsIdSelected = itemsSelected.map(item => item.id);
    try {
      await Promise.all(
        itemsIdSelected.map(
          async itemId =>
            await ApolloClient.mutate({
              mutation: Mutations.deleteItems,
              variables: { customFieldId: parseInt(itemId) }
            })
        )
      );
      await this._getList();
    } catch (errorsOnSave) {
      this.setState({
        errorsOnSave
      });
    } finally {
      this.setState({ deleting: false, rowsSelected: [] });
    }
  };

  render() {
    const { t, classes } = this.props;

    if (this.state.error) {
      return <ErrorNotification message="Error loading page" />;
    }

    return (
      <Table
        name={t('Shipment Reference Field')}
        columns={ShipmentReferencesTableMetadata.columns({ t })}
        data={this.state.items}
        page={this.state.page}
        rowsPerPage={this.state.rowsPerPage}
        rowComponent={props => (
          <DvExTable.Row
            {...props}
            className={classes.tableRow}
            onClick={() => this._handleRowClick(props.row)}
          />
        )}
        totalCount={this.state.totalCount}
        loading={this.state.loading}
        withDownload={false}
        withColumnChooser={false}
        withSelection={true}
        withPagination={true}
        rowsSelected={this.state.rowsSelected}
        onSelectRow={this._handleSelectRow}
        onChangePage={this._changePage}
        onChangePageRowsPerPage={this._changeRowsPerPage}
        onDelete={this._handleDelete}
        deleting={this.state.deleting}
      />
    );
  }
}

ShipmentReferencesTable.contextType = AppContext;
export default withStyles(styles)(
  withNamespaces()(withApollo(ShipmentReferencesTable))
);
